export enum CaseTypes {
  OPEN = "Open",
  CLOSED = "Closed",
  NEXT_DUE_DATE = "Freezed",
  SENT_TO_COURT = "SendToCourt",
  SENTENCE_RECEIVED = "SentenceReceived",
  MANUAL = "Manual",
}
